import {
  Component,
  Input,
  Output,
  EventEmitter,
  forwardRef,
  ChangeDetectorRef,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-checkbox',
  templateUrl: './app-checkbox.component.html',
  styleUrls: ['./app-checkbox.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AppCheckboxComponent),
      multi: true,
    },
  ],
})
export class AppCheckboxComponent implements ControlValueAccessor {
  @Input() label: string = '';
  @Input() labelText: string = '';
  @Input() disabled: boolean = false;
  @Input() indeterminate: boolean = false;
  @Input() id: string = '';
  @Input() name: string = '';
  @Input() customClass: string = '';

  private _checked: boolean = false;
  @Input()
  get checked(): boolean {
    return this._checked;
  }
  set checked(val: boolean) {
    this._checked = Boolean(val);
    this.cdr.markForCheck();
  }

  @Output() checkboxChange = new EventEmitter<boolean>();
  @Output() change = new EventEmitter<boolean>();

  private onChange: (value: boolean) => void = () => {};
  private onTouched: () => void = () => {};

  constructor(private cdr: ChangeDetectorRef) {}

  writeValue(val: any): void {
    this._checked = Boolean(val);
    this.cdr.markForCheck();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  toggle(event?: MouseEvent): void {
    if (this.disabled) return;
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (this.indeterminate) {
      this.indeterminate = false;
      this.checked = true;
    } else {
      this.checked = !this.checked;
    }

    this.onChange(this.checked);
    this.onTouched();
    this.checkboxChange.emit(this.checked);
    this.change.emit(this.checked);
  }
}
